export default __webpack_public_path__ + "static/about-us-security--mobile-6e948ce5a05672e2f15683172fce9a87.jpg";